module.exports = __webpack_public_path__ + "static/media/science_atom.8c624705.png";